module.exports = __webpack_public_path__ + "40f3a3be850ec1ad1aedcc0061efa989.svg";